/**
 * USP Bar – Mobile horizontal slider with arrow indicator
 *
 * On mobile (< 750px):
 *  - Slides items right→left every 3s, then back left→right (ping-pong)
 *  - Shows a small arrow on the right indicating more content
 *  - Arrow disappears after the first auto-slide
 *
 * On desktop: all items are visible in a row (no JS needed)
 */
(function () {
    'use strict';

    var INTERVAL = 3000;
    var MOBILE_BREAKPOINT = 750;

    function init() {
        var container = document.querySelector('.usp-bar__container');
        if (!container) return;

        var items = container.querySelectorAll('.usp-bar__item');
        if (items.length <= 1) return;

        var currentIndex = 0;
        var direction = 1;
        var timer = null;
        var arrowHidden = false;

        // Create the arrow indicator
        var arrow = document.createElement('span');
        arrow.className = 'usp-bar__arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
        container.appendChild(arrow);

        function isMobile() {
            return window.innerWidth < MOBILE_BREAKPOINT;
        }

        function updateSlide() {
            var offset = -currentIndex * 100;
            for (var i = 0; i < items.length; i++) {
                items[i].style.transform = 'translateX(' + offset + '%)';
            }
        }

        function advance() {
            // Ping-pong: reverse at boundaries
            if (currentIndex + direction >= items.length) {
                direction = -1;
            } else if (currentIndex + direction < 0) {
                direction = 1;
            }

            currentIndex += direction;
            updateSlide();

            // Hide arrow after first slide
            if (!arrowHidden) {
                arrowHidden = true;
                arrow.classList.add('is-hidden');
            }
        }

        function startRotation() {
            stopRotation();
            if (!isMobile()) return;
            updateSlide();
            timer = setInterval(advance, INTERVAL);
        }

        function stopRotation() {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        }

        // Handle resize
        var resizeTimer = null;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                if (isMobile()) {
                    if (!timer) startRotation();
                } else {
                    stopRotation();
                    // Reset transforms and arrow on desktop
                    for (var i = 0; i < items.length; i++) {
                        items[i].style.transform = '';
                    }
                    currentIndex = 0;
                    direction = 1;
                    arrowHidden = false;
                    arrow.classList.remove('is-hidden');
                }
            }, 150);
        });

        // Init on mobile
        if (isMobile()) {
            startRotation();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
